<template>
  <!-- 仅韩国人认证 -->
  <krwManagement v-if="coinsKrwOpen === '1'" />
  <!-- 普通认证 -->
  <UserManagement v-else-if="coinsKrwOpen === '0'" />
</template>

<script>
import krwManagement from './krwManagement.vue';
import UserManagement from './UserManagement.vue';

export default {
  name: 'management',
  components: {
    krwManagement,
    UserManagement,
  },
  computed: {
    // 开启验证方式
    coinsKrwOpen() {
      const { publicInfo } = this.$store.state.baseData;
      let str = '';
      if (publicInfo) {
        if (publicInfo.switch && publicInfo.switch.coins_krw_open) {
          str = publicInfo.switch.coins_krw_open.toString();
        } else {
          str = '0';
        }
      }
      return str;
    },
  },
};

</script>
